export default __webpack_public_path__ + "static/media/BRAINWELLNESS_ICONA.0827b54e.svg";